import { DeliveryIconComponent, ReserveIcon } from "../../../../../../../../../Components/IconComponents";
import PackageIcon from "../../../../../../../../../Components/IconComponents/packageIcon";
import useLanguagesHooks from "../../../../../../../../../Components/Languages/setLanguage-hooks";
import { IDeliveryOrderData, IOrderParams, IPreOrderData, IReserveOrderData, OrderTypes } from "../../../../../../../../../Interfaces/componentTypes";
import { formatDate, formatTime } from "../../../../../../../../../Utilits/utilits";
import styles from './orderCard.module.scss';

interface OrderCardContent {
  icon: JSX.Element;
  typeLabel: string;
  extraFields: JSX.Element[];
}

const useMyOrderCards = () => {
  const { t } = useLanguagesHooks();

  function getOrderCardContent(
    order_type: OrderTypes,
    order_parameters: IOrderParams,
    data: string
  ): OrderCardContent {
    let parsedData: IDeliveryOrderData | IPreOrderData | IReserveOrderData;

    try {
      parsedData = JSON.parse(data);
    } catch {
      parsedData = {} as any;
    }
    switch (order_type) {
      case OrderTypes.DELIVERY:
        return {
          icon: <DeliveryIconComponent width={40} height={40} />,
          typeLabel: t('Visitor.My_Order_Card.Delivery'),
          extraFields: [
            <p key="items">{t('Visitor.My_Order_Card.Items')}
              <span >{order_parameters.totalItems}</span></p>,
            <p key="delivery">{t('Visitor.My_Order_Card.Delivery_Fee')}
              <span>{(parsedData as IDeliveryOrderData).delivery_cost} ֏</span></p>,
            <p key="cost">{t('Visitor.Total')} <span style={{ marginLeft: '4px' }}>{parsedData.total_cost}</span> ֏</p>,
          ],
        };

      case OrderTypes.PREORDER:
        return {
          icon: <PackageIcon width={40} height={40} />,
          typeLabel: t('Visitor.My_Order_Card.Pre_Order'),
          extraFields: [
            <p key="items">{t('Visitor.My_Order_Card.Items')}
              <span >{order_parameters.totalItems}</span></p>,
            <p key="cost">  {t('Visitor.Total')} <span style={{ marginLeft: '4px' }}>{parsedData.total_cost}</span> ֏</p>,
          ],
        };

      case OrderTypes.RESERVE:
        return {
          icon: <ReserveIcon width={40} height={40} />,
          typeLabel: t('Visitor.My_Order_Card.Reserve'),
          extraFields: [
            <p key="persons">{t('Visitor.Reserve.Persons')}: {order_parameters.persons_count}</p>,
            <p key="items">{t("Visitor.My_Order_Card.Date")}
              <span >{formatDate(order_parameters.date!, false)} {formatTime(order_parameters.time!)}</span></p>,
            order_parameters.totalItems ?
              <p key="items">{t('Visitor.My_Order_Card.Items')}
                <span >{order_parameters.totalItems}</span></p>
              :
              <div />,
            parsedData.total_cost
              ?
              < p key="cost" > {t('Visitor.Total')}
                < span style={{ marginLeft: '4px' }} > {parsedData.total_cost}</span > ֏</p >
              :
              <div />,
          ],
        };

      default:
        return {
          icon: <></>,
          typeLabel: "Unknown Order",
          extraFields: [],
        };
    }
  };

  const truncateCompanyName = (name: string) => {
    return name.length > 9 ? name.slice(0, 9) + "..." : name;
  };

  return {
    getOrderCardContent,
    truncateCompanyName
  }

};

export default useMyOrderCards

